const BASE_URL = '';

export const URLS = {
  DRIVER: {
    BYPASS: `${BASE_URL}/driver-bypass`,
    LICENSE: `${BASE_URL}/driver-license`,
    ADD: `${BASE_URL}/driver-add`,
    EDIT: `${BASE_URL}/driver-edit`,
  },
  VEHICLE: {
    START: `${BASE_URL}/vehicle`,
    BYPASS: `${BASE_URL}/vehicle-bypass`,
    ADD: `${BASE_URL}/vehicle-add`,
    EDIT: `${BASE_URL}/vehicle-edit`,
  },
  COMPANY: {
    LANDING: `${BASE_URL}/company-landing`,
    DETAILS: `${BASE_URL}/company-details`,
    ADDRESS: `${BASE_URL}/company-address`,
    GARAGING_ADDRESS: `${BASE_URL}/garaging-address`,
    // WAITING_LIST: `${BASE_URL}/waiting-list`,
  },
  FREIGHT: `${BASE_URL}/add-freight`,
  APPLICATION: {
    INSURANCE: `${BASE_URL}/insurance`,
    POLICY: `${BASE_URL}/policy`,
    RISK_HISTORY: `${BASE_URL}/risk-history`,
    GROWTH_AND_OWNERSHIP: `${BASE_URL}/growth-and-ownership`,
    LOSS: `${BASE_URL}/loss`,
    CONFIRM: `${BASE_URL}/confirm`,
  },
  QUOTE: {
    PURCHASE: `${BASE_URL}/quote`,
    SUCCESS: `${BASE_URL}/quote-success`,
  },
};
